import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { api } from '../../../models/api-url.model';
import { IQObservation } from '../../../models/iq-observation.model';
import { ApiService } from '../api';
import { GetObservationsSummaryArgs } from './iq-observation.types';

@Injectable({
  providedIn: 'root',
})
export class IQObservationService {
  private readonly apiService = inject(ApiService);

  getObservations({
    showMockData,
  }: GetObservationsSummaryArgs): Observable<IQObservation[]> {
    const httpParams = new HttpParams().set('showMockData', showMockData);

    return this.apiService
      .get(api.getObservationsSummary, {
        params: httpParams,
      })
      .pipe(map((data) => data.items ?? data.records ?? []));
  }
}
